import { StaticImage } from 'gatsby-plugin-image'
import React from 'react'

import ExternalLink from '../ExternalLink'

const SidebarBanner = () => (
  <ExternalLink href="https://www.financeads.net/tc.php?t=72606C404086308B" className='plausible-event-name=sidebarBannerLinkClick'>
    <StaticImage src="https://www.fndsda.net/b/helios/Banniere_standard_250x300.png" width={250} height={300} alt="" />
  </ExternalLink>
)

SidebarBanner.propTypes = {}

export default SidebarBanner
